/**
 * The Home container
 */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Container } from "reactstrap";

// import {setLanguage} from "redux-i18n";
import Hero from "../../components/Hero";
import Page from "../../components/Page";
import CMSBlock from "../../components/CMSBlock";
import Perks from "../../components/Perks";
import { loadHome } from "../../redux/xapis";
import cmsBlocksSelectors from "../../redux/cmsblocks/selectors";
import filter from "lodash/filter";
import orderBy from "lodash/orderBy";
import { useSsrEffect } from "@issr/core";
import HighlightProducts from "../../components/HighlightProducts";
const _ = {
  orderBy: orderBy,
  filter: filter,
};
/**
 * Home container used as app default landing page
 */
const Home = (props, context) => {
  const dispatch = useDispatch();
  const language = useSelector((state) => {
    return state.i18nState.lang;
  });

  const dataLayer = [
    {
      event: "view_item_list",
      value: 100,
      items: [
        { id: "sticker-vehicle-motif", google_business_vertical: "retail" },
        {
          id: "sticker-vehicle-own-design",
          google_business_vertical: "retail",
        },
        { id: "Klebeschrift nach Wunsch", google_business_vertical: "retail" },
        {
          id: "Klebefolie selbst gestalten",
          google_business_vertical: "retail",
        },
        { id: "3001", google_business_vertical: "retail" },
        { id: "3040", google_business_vertical: "retail" },
        { id: "window-film-design", google_business_vertical: "retail" },
        {
          id: "customised-text-as-a-wall-sticker",
          google_business_vertical: "retail",
        },
        { id: "sticker-own-logo", google_business_vertical: "retail" },
        { id: "logo-shop-window", google_business_vertical: "retail" },
        { id: "text", google_business_vertical: "retail" },
        {
          id: "Beschriftung aus Klebefolie",
          google_business_vertical: "retail",
        },
        { id: "adhesive-letters", google_business_vertical: "retail" },
        {
          id: "Fahrzeugbeschriftung mit individuellem Text",
          google_business_vertical: "retail",
        },
        { id: "individual-vinyl-print", google_business_vertical: "retail" },
        {
          id: "individual-vinyl-print-premium",
          google_business_vertical: "retail",
        },
      ],
    },
    {
      ecommerce: {
        detail: {
          actionField: {
            list: "LandingPage",
          },
          products: [
            {
              name: "Schaufensterfolie mit Deinem Motiv - Nutze Dein Schaufenster als potenzielle Werbefläche",
              id: "window-film-design",
              price: "86.75",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Schaufensteraufkleber mit Logo Druck - Schnell und einfach zum Schaufensteraufkleber",
              id: "logo-shop-window",
              price: "4.99",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|Für Friseure|Für Arztpraxen|Raumbeschriftung|Für dein Schaufenster|Wandtattoos|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Digitaldruck auf Standard Klebefolie - Dein Design als Autoaufkleber, Schaufensterkleber oder Sticker",
              id: "individual-vinyl-print",
              price: "4.99",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|Für Friseure|Für Arztpraxen|Raumbeschriftung|Für dein Schaufenster|Wandtattoos|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Fahrzeugaufkleber mit Deinem Motiv - Individuell nach deinen Vorgaben produziert",
              id: "sticker-vehicle-motif",
              price: "4.99",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|Für Friseure|Für Arztpraxen|Raumbeschriftung|Für dein Schaufenster|Wandtattoos|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Fahrzeugbeschriftung mit individuellem Text",
              id: "Fahrzeugbeschriftung mit individuellem Text",
              price: "4.95",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Wegweiser|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Lochfolie mit eigenem Motiv",
              id: "Lochfolie mit eigenem Motiv",
              price: "7.37",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Nach Motiv|Abi Aufkleber|Flaggen & Länder|Lustige Sprüche",
            },
            {
              name: "Klebefolie als eigenes Motiv",
              id: "Klebefolie als eigenes Motiv",
              price: "4.99",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Nach Motiv|Abi Aufkleber|Flaggen & Länder|Lustige Sprüche",
            },
            {
              name: "Klebebuchstaben - Schriftart, Farbe und Größe frei wählbar",
              id: "adhesive-letters",
              price: "4.95",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Wegweiser|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Klebeschrift nach Wunsch",
              id: "Klebeschrift nach Wunsch",
              price: "4.95",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Wegweiser|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Klebefolie selbst gestalten",
              id: "Klebefolie selbst gestalten",
              price: "4.95",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Wegweiser|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Fahrzeugbeschriftung mit individuellem Text",
              id: "Fahrzeugbeschriftung mit individuellem Text",
              price: "4.95",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Wegweiser|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Beschriftung aus Klebefolie",
              id: "Beschriftung aus Klebefolie",
              price: "4.95",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Wegweiser|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
            {
              name: "Beschriftung aus Klebefolie",
              id: "text",
              price: "4.95",
              category:
                "Für dein Gewerbe|Für dein Fahrzeug|Nach Gewerbe|Für Restaurants|Für Cafés|Für Imbisse|Für dein Büro|Nach Einsatzzweck|\u00d6ffnungszeiten|Für Friseure|Für Arztpraxen|Wegweiser|Raumbeschriftung|Für dein Schaufenster|Nach Motiv|Für Ladengeschäfte",
            },
          ],
        },
      },
    },
  ];
  const homeCMSBlocks = useSelector((state) =>
    cmsBlocksSelectors.selectCMSBlocksForPage(
      state,
      state.xapis.homeCMSBlocksSlugs
    )
  );
  const frontload = async () => {
    if (homeCMSBlocks.length > 0) return;
    dispatch(loadHome());
  };

  useSsrEffect(frontload, [language]);

  const introBlock = _.filter(homeCMSBlocks, function (cmsBlock) {
    return cmsBlock.slug === "home_intro";
  });

  const overviewCmsBlocks = _.filter(homeCMSBlocks, function (cmsBlock) {
    return cmsBlock.slug !== "home_intro";
  });

  const sortedOverviewCmsBlocks = _.orderBy(
    overviewCmsBlocks,
    [(o) => o.priority == null || o.priority === "", "priority"],
    ["asc", "desc"] // 1) non-empty before empty, 2) highest → lowest
  );

  return (
    <Page
      id="home"
      title={context.t("Order stickers and adhesive film online at myfolie")}
      lang={language}
      dataLayer={dataLayer}
      pageType="home"
      description={context.t(
        "Now create your adhesive labels and adhesive letters online. ✓individual ✓ many fonts ✓ many colors ✓ on account"
      )}
      image="https://cdn.myfolie.de/media/banner/800x500.png"
    >
      <Hero lang={language} />
      {introBlock[0] && (
        <Container className="my-5 text-center">
          <CMSBlock cmsBlock={introBlock[0]} />
        </Container>
      )}

      <HighlightProducts />
      <div className="mt-5 bg-light">
        <Perks />
      </div>

      {sortedOverviewCmsBlocks?.map((cmsBlock, idx) => {
        return (
          <>
            <Container key={"cmsblock-" + idx} className={"my-5 py-3"}>
              <CMSBlock cmsBlock={cmsBlock} invert={idx % 2} />
            </Container>
          </>
        );
      })}
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
Home.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default Home;
